import { ShoppingCartData, ShoppingCartItem } from '@models/shopping-cart.model';

export const CostInfo: {
  one_time_cost: string;
  recurring_cost: string;
} = {
  one_time_cost: '- -',
  recurring_cost: '- -'
};

export class CategoryData {
  id: number;
  value: string;
}

export const CategoryInfo: {
  category_list: CategoryData[];
} = {
  category_list: [] as CategoryData[]
};

export const CartInfo: {
  cart_data: ShoppingCartData | undefined;
} = {
  cart_data: undefined
};
